// extracted by mini-css-extract-plugin
module.exports = {"form":"ModalSign_form__1sxyj","signatureButtonsRight":"ModalSign_signatureButtonsRight__BLFpb"};